module.exports = __webpack_public_path__ + "static/media/drunk_dirk_nash.436e0b75.jpg";